import { COUNTRY } from '@/config';

const SERVICE_URL_BY_BRAND = {
  br: 'https://status.hostgator.com.br/',
  mx: 'https://status.hostgator.mx/',
  co: 'https://status.hostgator.mx/',
  cl: 'https://status.hostgator.mx/',
  ar: 'https://status.hostgator.mx/',
  pe: 'https://status.hostgator.mx/',
  bo: 'https://status.hostgator.mx/',
  cr: 'https://status.hostgator.mx/',
  do: 'https://status.hostgator.mx/',
  ec: 'https://status.hostgator.mx/',
  sv: 'https://status.hostgator.mx/',
  pa: 'https://status.hostgator.mx/',
  py: 'https://status.hostgator.mx/',
  uy: 'https://status.hostgator.mx/',
};

export const SERVICE_STATUS_URL = SERVICE_URL_BY_BRAND[COUNTRY];
